import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import MessageSettingsService from 'cio/services/message-settings';
import IndexController from './controller';
import SegmentAuthService from 'cio/services/segment-auth';
import Transition from '@ember/routing/-private/transition';
import Model from '@ember-data/model';

export default class IndexRoute extends Route {
  @service messageSettings!: MessageSettingsService;
  @service segmentAuth!: SegmentAuthService;

  setupController(controller: IndexController, model: Model, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.fetchIntegrations.perform();
    controller.reportingWebhooks.perform();
    controller.segmentOut.perform();
    this.segmentAuth.segmentIn.perform();
    controller.fetchCredentials.perform();
    controller.fetchAdAudiences.perform();
    this.messageSettings.loadURLParamsCredential.perform();
    controller.fetchMparticle.perform();
    controller.fetchCdpOut.perform();
    controller.fetchWarehouseSync.perform();
    controller.fetchSQLImports.perform();
    controller.loadForms.perform();
    controller.fetchAPIKeys.perform();
    controller.fetchCampaigns.perform();
  }

  resetController(controller: IndexController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);
    if (isExiting) {
      controller.setProperties({
        query: '',
        selectedCategory: '',
      });
    }
  }
}
